var exports = {
  "Tp": "x04b3a21e--f8b4f9--background",
  "kL": "x04b3a21e--f8b4f9--container",
  "QX": "x04b3a21e--f8b4f9--main-block-content",
  "DD": "x04b3a21e--f8b4f9--title",
  "cY": "x04b3a21e--f8b4f9--offset",
  "xN": "x04b3a21e--f8b4f9--title-builder",
  "tJ": "x04b3a21e--f8b4f9--title-name",
  "o1": "x04b3a21e--f8b4f9--actions",
  "KQ": "x04b3a21e--f8b4f9--main-block",
};

module.exports = exports;
